<template>
  <div id="container" style="margin: 0;height: 100%;"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { EventBus } from '../EventBus'

export default {
  data() {
    return {
      map: null,
      AMap: null,
      markers: [],
    };
  },
  methods: {
    initMarker({ x, y, title = '北京', text = '冀J12345', color, data: { driver, tel, info, state, gpstime, speed, direct, type } }) {
      var marker = new this.AMap.Marker({
        position: new this.AMap.LngLat(x, y),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title,
        offset: new this.AMap.Pixel(0, 0)
      });

      // 给标记点绑定数据
      marker['license'] = text
      marker['x'] = x
      marker['y'] = y

      marker.setContent(`<div class="marker" >
        <div class="tit ${color ? 'tit' + color : ''}">${text}<div class="after"></div></div>
        <div class="cont ${type === '在线' ? '' : 'off'}" id="mark${text}" style="transform:rotate(${90 + direct}deg);"></div>
      </div>`);

      // console.log(marker)

      var tit = `${text}`, content = [];
      if (driver) content.push(`司机：${driver}`);
      if (tel) content.push(`电话：${tel}`);
      if (gpstime) {
        const { y, m, d } = this.getDateStrObj(gpstime)
        content.push(`时间：${y}-${m}-${d}`);
      }
      if (state) content.push(`状态：${state}`);
      content.push(`速度：${speed}`);
      if (info) content.push(`位置：${info}`);
      // content.push(`<div class="mapbtn" id="positionbtn${text}">位置</div>`)
      var infoWindow = new this.AMap.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: this.createInfoWindow(tit, content.join("<br/>")),
        offset: new this.AMap.Pixel(16, -45)
      });

      //鼠标点击marker弹出自定义的信息窗体
      // this.AMap.event.addListener(marker, 'click', function () {
      //   infoWindow.open(this.map, marker.getPosition());
      // });

      setTimeout(() => {
        // 绑定图标点击事件
        const mark = document.querySelector(`#mark${text}`)
        const mapp = this.map
        const fun = this.showAllLisence
        if (mark) {
          mark.onclick = function () {
            // 显示全部
            fun()
            // 隐藏当前
            const tit = this.previousElementSibling
            tit.classList.add('hide')
            // 打开窗体
            infoWindow.open(mapp, marker.getPosition());
          }
        }
        const btn = document.querySelector(`#positionbtn${text}`)
        if (btn) {
          btn.onclick = function () {
            console.log(this)
          }
        }
      }, 1);

      // 将创建的点标记添加到已有的地图实例：
      this.map.add(marker);

      // 储存标记点
      this.markers.push(marker)

      return marker;
    },
    //构建自定义信息窗体
    createInfoWindow(title, content) {
      var info = document.createElement("div");
      info.className = "custom-info input-card content-window-card";

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement("div");
      var titleD = document.createElement("div");
      var closeX = document.createElement("img");
      top.className = "info-top";
      titleD.innerHTML = title;
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.onclick = this.closeInfoWindow;
      closeX.style.cursor = 'pointer';

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.backgroundColor = 'white';
      middle.innerHTML = content;
      info.appendChild(middle);

      // 定义按钮
      var btns = document.createElement("div");
      btns.className = "btns";
      btns.style.backgroundColor = 'white';
      // 位置按钮
      var btn1 = document.createElement("div");
      btn1.innerHTML = '实时轨迹'
      btn1.className = 'mapbtn'
      btn1.onclick = () => {
        // console.log(this)
        this.$router.push(`/vehicle/position?license=${title}`)
      }
      btns.appendChild(btn1)
      // 轨迹按钮
      var btn2 = document.createElement("div");
      btn2.innerHTML = '历史轨迹'
      btn2.className = 'mapbtn'
      btn2.onclick = () => {
        // console.log(this)
        this.post(`car/history`, { license: title }, ({ msg, url }) => {
          if (msg === 'success' && url) {
            // location.href = url
            this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${title + '历史轨迹'}`)
          }
        }, err => {
          console.log(err)
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！'
          });
        })
      }
      btns.appendChild(btn2)
      info.appendChild(btns)

      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = 'relative';
      bottom.style.top = '0px';
      bottom.style.margin = '0 auto';
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    //关闭信息窗体
    closeInfoWindow() {
      this.map.clearInfoWindow();
      this.showAllLisence()
    },
    showAllLisence() {
      const array = document.querySelectorAll('.marker .hide')
      for (let i = 0; i < array.length; i++) {
        const e = array[i];
        e.classList.remove('hide')
      }
    },
    getData(isRefresh) {
      let fix = 0.5
      this.post(`index/getcarlocation`, {}, res => {
        console.log(res)
        if (res.msg !== 'success') {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！'
          });
          return
        }
        const { location, maxlng, maxlat, minlng, minlat } = res;
        if (location && location[0]) {
          const { lng, lat } = location[0]
          if (!isRefresh) this.map.setCenter([lng, lat]);
          for (var i = 0; i < location.length; i++) {
            var p = location[i];
            // console.log(p)
            this.initMarker({
              x: p.lng,
              y: p.lat,
              text: p.name,
              data: p,
            })
          }
        }
        var mybounds = new this.AMap.Bounds([Number(maxlng) + fix, Number(maxlat) + fix], [Number(minlng) - fix, Number(minlat) - fix])
        this.map.setBounds(mybounds);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    selectLisence(s) {
      // console.log('a', s)
      // console.log(this.markers)
      this.markers.map(v => {
        if (v.license === s) {
          // console.log({ ...v })
          // console.log(this.map)
          const { x, y } = v
          // this.map.setCenter([x, y])
          // console.log([x, y])
          this.map.setZoomAndCenter(20, [x, y])
          // 打开弹窗会造成偏差
          // setTimeout(() => {
          //   const img = v.dom.querySelector('.img')
          //   // console.log(img)
          //   if (img) img.click()
          // }, 800);
        }
      })
    },
  },
  created() {
    EventBus.$on('selectLisence', this.selectLisence);
  },
  beforeDestroy() {
    EventBus.$off('selectLisence', this.selectLisence);
  },
  mounted() {
    AMapLoader.load({
      key: "00ef8e16ac1dc02bfea2dd248b61a58f", // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      // plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    })
      .then((AMap) => {
        this.map = new AMap.Map("container", {
          center: [117.317026, 38.359087],
          zoom: 15,
        });
        this.AMap = AMap
        this.$nextTick(this.getData)
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>

<style lang="less" scoped>
#container {
  width: 100%;
  height: 100%;

  /deep/ .marker {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tit {
      background-color: rgba(0, 0, 0, 0.65);
      color: #FFF;
      padding: 5px;
      border-radius: 5px;
      min-width: 80px;
      text-align: center;
      margin-bottom: 8px;
      position: relative;

      &.hide {
        visibility: hidden;
      }

      .after {
        contain: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 0px;
        border: 5px solid transparent;
        border-top-color: rgba(0, 0, 0, 0.65);
      }
    }

    .tit1 {
      background-color: #F56C6C;

      .after {
        border-top-color: #F56C6C;
      }
    }

    .tit2 {
      background-color: #3696F9;

      .after {
        border-top-color: #3696F9;
      }
    }

    .tit3 {
      background-color: #C832C8;

      .after {
        border-top-color: #C832C8;
      }
    }

    .tit4 {
      background-color: #00CFBA;

      .after {
        border-top-color: #00CFBA;
      }
    }

    .tit5 {
      background-color: #67C23A;

      .after {
        border-top-color: #67C23A;
      }
    }

    .tit6 {
      background-color: #FE3E3E;

      .after {
        border-top-color: #FE3E3E;
      }
    }

    .cont {
      width: 55px;
      height: 55px;
      background: url(../assets/img/fleet01.png) no-repeat center center;
      background-size: 100%;
      margin-top: -5px;

      &.off {
        background-image: url(../assets/img/fleet01_off.png);
      }
    }
  }

  /deep/.btns {
    padding: 0 10px 10px;

    .mapbtn {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: .1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 4px;
      font-size: 12px;
      border-radius: 3px;
      padding: 7px 15px;
      background: #66b1ff;
      border-color: #66b1ff;
      color: #fff;
      z-index: 999;
      position: relative;
      margin-right: 10px;
    }
  }
}



/deep/.custom-info {
  border: solid 1px silver;

  &.content-window-card {
    position: relative;
    box-shadow: none;
    bottom: 0;
    left: 0;
    width: auto;
    padding: 0;

    p {
      height: 2rem;
    }

    .info-top {
      position: relative;
      background: none repeat scroll 0 0 #F9F9F9;
      border-bottom: 1px solid #CCC;
      border-radius: 5px 5px 0 0;

      div {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 31px;
        padding: 0 10px;
      }

      img {
        position: absolute;
        top: 10px;
        right: 10px;
        transition-duration: 0.25s;

        &:hover {
          box-shadow: 0px 0px 5px #000;
        }
      }
    }

    .info-middle {
      font-size: 12px;
      padding: 10px 6px;
      line-height: 20px;

      img {
        float: left;
        margin-right: 6px;
      }
    }

    .info-bottom {
      height: 0px;
      width: 100%;
      clear: both;
      text-align: center;

      img {
        position: relative;
        z-index: 104;
      }

      span {
        margin-left: 5px;
        font-size: 11px;
      }
    }
  }
}
</style>
